import { type ErrorType, apiRequest } from "../api";
import type { Call, LiveKitTokenResponse } from "./call.api";

// ─── Service ─────────────────────────────────────────────────────────────────

export const clientCallService = {
  /** Atende a chamada recebida — muda o status pra `active`. */
  async answer(id: string): Promise<[Call | null, ErrorType | null]> {
    return apiRequest<Call>({
      loaderKey: "answerClientCall",
      method: "post",
      url: `/app/client/calls/${id}/answer`,
    });
  },

  /** Recusa a chamada recebida. */
  async decline(id: string): Promise<[Call | null, ErrorType | null]> {
    return apiRequest<Call>({
      loaderKey: "declineClientCall",
      method: "post",
      url: `/app/client/calls/${id}/decline`,
    });
  },

  async hangup(
    id: string,
    reason?: string
  ): Promise<[Call | null, ErrorType | null]> {
    return apiRequest<Call>({
      loaderKey: "hangupClientCall",
      method: "post",
      url: `/app/client/calls/${id}/hangup`,
      data: { reason },
    });
  },

  /** Busca a chamada por id — usado como fallback de status (poll) caso o socket perca o evento de encerramento. */
  async getById(id: string): Promise<[Call | null, ErrorType | null]> {
    return apiRequest<Call>({
      loaderKey: "getClientCallById",
      method: "get",
      url: `/app/client/calls/${id}`,
    });
  },

  /** Token de acesso LiveKit (URL do servidor + JWT) pro lado do cliente. */
  async getLiveKitToken(
    id: string
  ): Promise<[LiveKitTokenResponse | null, ErrorType | null]> {
    return apiRequest<LiveKitTokenResponse>({
      loaderKey: "getClientCallLiveKitToken",
      method: "get",
      url: `/app/client/calls/${id}/livekit-token`,
    });
  },

  /** Chamada em `ringing`/`active` do ticket, se houver — usado pro banner de "chamada em andamento" no portal do cliente. */
  async getActiveForTicket(
    ticketId: string
  ): Promise<[Call | null, ErrorType | null]> {
    return apiRequest<Call | null>({
      loaderKey: "clientActiveCallForTicket",
      method: "get",
      url: `/app/client/tickets/${ticketId}/active-call`,
      ignoreError: true,
    });
  },
};
